<template lang="pug">
  v-select(
    @input='$emit("update", block)'
    v-model='block.value'
    :items='list'
    item-value='id'
    item-text='name'
    label='Выберите форму'
  )
</template>

<script>
import BaseBlock from './BaseBlock'
import { requestTypes } from '@/enums/request-types'
import PropTypes from '@znck/prop-types'

export default {
  extends: BaseBlock,

  props: {
    block: PropTypes.shape({
      type: PropTypes.string.isRequired,
      value: PropTypes.oneOf(requestTypes.toArray().map(b => b.id))
    })
  },

  data: function() {
    return {
      list: requestTypes.toArray()
    }
  }
}
</script>
